import { createSelector } from "reselect";
import { AppState } from "state/app-state";

const getNetworkConnectionData = (state: AppState) => state.networkConnection.isConnected

export const getNetworkConnection = createSelector(
  getNetworkConnectionData,
  isConnected => isConnected
);
